import React from "react";
import { Canvas } from "@react-three/fiber";
import { OrbitControls, PerspectiveCamera } from "@react-three/drei";
import {
  EffectComposer,
  Noise,
} from "@react-three/postprocessing";

import Coin from "../../components/Coin";
import images from "../../constants/images";
import "./Header.scss";

const Header = () => {
  const handleClick = () => {
    window.scrollTo({ top: 800, behavior: "smooth" });
  };

  return (
    <div id="header">
      <div className="headline">
        <h1>HORUSCHILD</h1>
        <h3>COOLEST SHOW OFF PLATFORM</h3>
      </div>
      <img src={images.coin} alt="" />
      <div className="canvas-container">
        <Canvas id="coin-canvas">
          <ambientLight intensity={1} />
          <pointLight position={[-5, 3, -3]} intensity={0.5} />
          <pointLight position={[-5, -7, 0]} intensity={0.5} />
          <pointLight position={[9, 20, 4]} intensity={1} />
          <pointLight position={[0, 0, -5]} intensity={1} />
          <Coin />
          <PerspectiveCamera makeDefault fov={75} position={[0, 0, 2]} />
          <OrbitControls enableZoom={false}/>

          <EffectComposer>
            <Noise opacity={0.2} />
            {/* <Bloom luminanceThreshold={0} luminanceSmoothing={1} height={300}/> */}
          </EffectComposer>
        </Canvas>
      </div>
      <div className="mouse" onClick={handleClick}>
        <p>SCROLL</p>
      </div>
    </div>
  );
};

export default Header;
